import { render } from "./Admin.vue?vue&type=template&id=bc6ce610"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=bc6ce610&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__